import React, { Component } from 'react'
import {Header, Form,Button, Message,Segment} from "semantic-ui-react"
import moment from 'moment'
import axios from 'axios'
import { destroy } from 'redux-form'
import { getHeader } from '../../data/user_api'
import { PROPERTY_VISIT_API_URL } from '../../constants/api_routes'
export default class SendSMS extends Component {


    state = {
        message:"",
        destNumber:"",
        sending:false,
        apiResponse:undefined,
        intNum:false
    }

    componentDidMount() {
this.setState({
    message: `Hinch Property Management: A routine Property Visit is scheduled at ${this.props.selectedPV.address} on ${moment(this.props.selectedPV.visit_date).format("DD/MM/YYYY")}, between ${this.props.selectedPV.visit_time}. The visit will take approx. 15 mins and includes a general property check, alarm testing and identifying any maintenance issues.

Please reply with:

YES - I will be available
CHANGE - I need a different date/time (please include some options)
KEYS - I give permission for management keys to be used while I'm out

More info: www.hinchpm.com/pv`
});
    }

    setMessageScheduledPV = () =>{
      this.setState({
    message: `Hinch Property Management: A routine Property Visit is scheduled at ${this.props.selectedPV.address} on ${moment(this.props.selectedPV.visit_date).format("DD/MM/YYYY")}, between ${this.props.selectedPV.visit_time}. The visit will take approx. 15 mins and includes a general property check, alarm testing and identifying any maintenance issues.

Please reply with:

YES - I will be available
CHANGE - I need a different date/time (please include some options)
KEYS - I give permission for management keys to be used while I'm out

More info: www.hinchpm.com/pv`
});
    }

    setMessagePVReminder = () =>{
        this.setState({
            message:`REMINDER - Hinch property visit scheduled for ${moment(this.props.selectedPV.visit_date).format("DD/MM/YYYY")} Time - ${this.props.selectedPV.visit_time} at ${this.props.selectedPV.address.slice(0,18)}`,
        }) 
    }
    handleSubmit = async () =>{ 

        if (this.state.destination) {}
        let postData = {
            "visit_id":this.props.selectedPV.id,
        "content":this.state.message,
        "sender":"447860099426",
        "destination":this.state.destNumber}
        this.setState({sending:true})
        try {
            const res = await axios.post(`${PROPERTY_VISIT_API_URL}/send_sms`, postData, {headers: getHeader()});
            this.setState({sending:false,apiResponse:JSON.stringify(res.data)})
        } catch (error) {
            console.log(JSON.stringify(error))
            this.setState({sending:false,apiResponse:error.response.data.error})
        }
    }
  render() {

    return (
        <div>
            <Header>Send an SMS</Header>
            <Segment>
                <Header as="h4">Templates </Header>

                <Button onClick={()=>{this.setMessageScheduledPV()}}>PV Scheduled Notification</Button>
                <Button onClick={()=>{this.setMessagePVReminder()}}>PV Reminder Notification</Button>
            </Segment>
            <div>
                <Form onSubmit={()=>{this.handleSubmit()}}>
                    <Form.Field inline>
                        <label>Numbers Available: {this.props.selectedPV.tenant_contact}</label>
                    </Form.Field>
                    <Form.Field inline>
                        <label>Number to send to (only 1 number per try, must start with 0 or 44)</label>
                        <Form.Input type="number" placeholder='Phone Number' value={this.state.destNumber} onChange={(e) =>{this.setState({destNumber:e.target.value})}} />
                        <Form.Checkbox label="International Number" onChange={(e,{checked})=>this.setState({intNum:checked?true:false})}></Form.Checkbox>
                    </Form.Field>
                    <Form.TextArea name="message" label="Text Message body"  onChange={(e)=>{this.setState({message:e.target.value})}}value={this.state.message}></Form.TextArea>
                <Button disabled={!this.state.intNum && (this.state.sending || this.state.destNumber.length < 11 ||this.state.destNumber.length > 12 || !(this.state.destNumber.startsWith("0") || this.state.destNumber.startsWith("44")))} loading={this.state.sending} type="submit">Send Message</Button>
                </Form>
                {this.state.apiResponse && <Message header="Api Response" ><p>{this.state.apiResponse}</p></Message>}
            </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/property_visits/send_sms.js